import { Component, inject, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FilesService } from 'src/app/services/files/files.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { requestInterface } from 'src/app/util/interfaces/request';
import { RequestPageAttachmentsService } from './data/request-page-attachments.service';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'pcp-request-page-tab-attachments',
	standalone: true,
	imports: [FontAwesomeModule],
	templateUrl: './request-page-tab-attachments.component.html',
	styleUrl: './request-page-tab-attachments.component.scss',
})
export class RequestPageTabAttachmentsComponent {
	private readonly RequestPageAttachmentsService = inject(RequestPageAttachmentsService);
	private readonly fileService = inject(FilesService);
	private readonly notificationService = inject(NotificationService);

	icons = {
		faDownload: faDownload,
	};

	@Input() requestData: requestInterface;

	formatAttachPath(filePath: string): string {
		if (filePath) {
			let splitedFilePath = [];
			splitedFilePath = filePath.includes('\\') ? filePath.split('\\') : filePath.split('/');

			return splitedFilePath.at(-1);
		}

		return '';
	}

	downloadFile(filePath: string): void {
		filePath = this.formatAttachPath(filePath);
		this.RequestPageAttachmentsService.getFile(filePath).subscribe(
			(mspFile) => {
				this.fileService.downloadFile(this.fileService.fileFromBase(mspFile, 'Base64'));
			},
			(error) => {
				this.notificationService.setNotificationMessage('Arquivo não encontrado.');
			}
		);
	}
}
